import { IThunderboltEntry } from '@wix/editor-elements-types';

import {
  registerComponentTypeUiTypes,
  UiTypesRegistrationMap,
} from '../../registration/registration';

const UiTypes: UiTypesRegistrationMap = {
  '': () => [import('./viewer/GoogleMap' /* webpackChunkName: "GoogleMap" */)],
};

const entry: IThunderboltEntry = {
  loadComponent: registerComponentTypeUiTypes('GoogleMap', UiTypes),
};

export default entry;
